import { supabaseClient } from "./supabase.service.js";

const UserLogin = function({ dom, message, onAuthStateChange}) {
  const _this = this;
  const {bad, info, progress, good} = message;
  const template = `  
    <div class="user-login-title">Log in</div>
    <div class="user-logged-title">&#x2714</div>
    <div class="user-logged-form-wrapper">
      <span class="user-logged-name"></span>
      <button class="user-logged-logout">Log out</button>
      <div class="user-account-actions">
        <button class="button user-change-password">Change password</button>
        <button class="button user-change-email">Change email</button>
        <button class="button user-delete-account delete danger">Delete account</button>
      </div>
    </div>
    <div class="user-login-form-wrapper how-to-outer">
      <div class="user-login-form fancy-art-deco-card">
        <div class="corner top left"></div>
        <div class="corner top right"></div>
        <div class="corner bottom left"></div>
        <div class="corner bottom right"></div>
        <span class="user-login-close button-close">×</span>
        <span>
          <form class="panel signup-panel">
            <span>Sign up</span>
            <label for="email"><b>E-mail</b></label>
            <input type="email" placeholder="Enter email" name="email" required>

            <label for="psw"><b>Choose Password</b></label>
            <input id="signup-psw" type="password" placeholder="Enter Password" name="psw" required minlength="6">

            <label for="psw2"><b>Confirm New Password</b></label>
            <input id="signup-psw2" type="password" placeholder="Enter Password" name="psw2" required minlength="6">

            <small class="error-msg"></small>
            <a class="forgot-password-link signup-forgot-link" style="display:none">Forgot password?</a>
            <button class="button button-signup">Create account</button>
          </form>
          <form class="panel login-panel">
            <span>Log in</span>
            <label for="email"><b>E-mail</b></label>
            <input type="email" placeholder="Enter email" name="email" required>

            <label for="psw"><b>Password</b></label>
            <input type="password" placeholder="Enter Password" name="psw" required minlength="6">

            <a class="forgot-password-link">Forgot password?</a>
            <small class="error-msg"></small>
            <button class="button button-login">Log in</button>
            
            <span class="login-oauth">
              <span class="button button-google-login">
                <i class="fa fa-2x fa-google"></i>
              </span>
              <span  class="button button-github-login">
                <i class="fa fa-2x fa-github"></i>
              </span>
            </span>
            <hr>
            <span class="hr-text-center">or</span>
            <span class="button button-switch-signup">Sign up</span>
          </form>
          <form class="panel forgot-panel">
            <span>Reset password</span>
            <label for="forgot-email"><b>E-mail</b></label>
            <input id="forgot-email" type="email" placeholder="Enter email" name="email" required>
            <small class="error-msg"></small>
            <button class="button button-confirm-reset">Confirm password reset</button>
            <span class="button button-back-to-login">Back to log in</span>
          </form>
        </span>
      </div>
    </div>
  `;

  const placeHolder = d3.select(dom).html(template);

  // const template = d3.create("div");
  // template.html(templateHtml);

  // for (const elem of Array.from(template.node().children)) {
  //   placeHolder.append(() => elem);
  // }

  this.isUserLoginOpen = false;
  
  placeHolder.select(".user-logged-title").on("click", () => {
    switchUserLogin();
  });

  placeHolder.select(".user-logged-logout").on("click", async () => {
    if (await userLogout()) {
      switchUserLogin();
      updateUserLogin();
    }
  });

  placeHolder.select(".user-login-title").on("click", () => {
    open()
  });

  placeHolder.select(".user-login-close").on("click", () => switchUserLogin());
  placeHolder.select(".button-switch-signup").on("click", ()=> {
    placeHolder.select(".user-login-form").classed("signup", true);
  });

  placeHolder.select(".signup-panel").on("submit", async event => {
    event.preventDefault();
    const data = new FormData(event.target);
    const emailInput = event.target.querySelector('input[name="email"]');
    const errorMsg = event.target.querySelector('.error-msg');
    emailInput.setCustomValidity("");
    errorMsg.textContent = "";
    const res = await userSignup(data.get("email"), data.get("psw"));
    if (res.error) {
      const msg = res.error.message ? res.error.message : String(res.error || 'Signup failed');
      if ((msg || "").toLowerCase().includes("already") || (res.error.status === 400)) {
        errorMsg.textContent = "This email is already registered.";
        event.target.querySelector('.signup-forgot-link').style.display = "";
      } else {
        errorMsg.textContent = msg;
        event.target.querySelector('.signup-forgot-link').style.display = "none";
      }
      return;
    }
    switchUserLogin();
    updateUserLogin();
  });

  placeHolder.select(".login-panel .forgot-password-link").on("click", () => {
    const email = placeHolder.select(".login-panel input[name='email']").property("value");
    switchToForgotPanel(email);
  });

  placeHolder.select(".signup-panel .forgot-password-link").on("click", () => {
    const email = placeHolder.select(".signup-panel input[name='email']").property("value");
    switchToForgotPanel(email);
  });

  placeHolder.select(".button-back-to-login").on("click", () => {
    placeHolder.select(".user-login-form").classed("forgot", false);
  });

  placeHolder.select(".forgot-panel").on("submit", async event => {
    event.preventDefault();
    const errorMsg = event.target.querySelector('.error-msg');
    errorMsg.textContent = '';
    const email = event.target.querySelector('input[name="email"]').value.trim();
    const { error } = await supabaseClient.auth.resetPasswordForEmail(email, {
      redirectTo: location.href
    });
    if (error) {
      errorMsg.textContent = error.message || String(error);
      return;
    }
    good('Reset link sent! Check your inbox.', 5000);
    placeHolder.select(".user-login-form").classed("forgot", false);
  });

  placeHolder.select(".login-panel").on("submit", async event => {
    event.preventDefault();
    const data = new FormData(event.target);
    const errorMsg = event.target.querySelector('.error-msg');
    errorMsg.textContent = '';
    const res = await userLogin(data.get("email"), data.get("psw"));
    if (res.success) {
      switchUserLogin();
      updateUserLogin();
    } else {
      const msg = res.error?.message || String(res.error || 'Login failed');
      errorMsg.textContent = msg.includes('Invalid') ? 'Wrong email or password' : msg;
    }
  });

  placeHolder.selectAll(".login-panel input").on("input.clearerr", () => {
    placeHolder.select(".login-panel .error-msg").text("");
  });

  placeHolder.select("#signup-psw").on("input", (event) => {
    const data = new FormData(event.target.form);
    placeHolder.select("#signup-psw2").node()
      .setCustomValidity(data.get("psw") !== data.get("psw2") ? "Passwords should be equal" : "");
  });

  placeHolder.select("#signup-psw2").on("input", (event) => {
    const data = new FormData(event.target.form);
    event.target.setCustomValidity("");
    event.target.setCustomValidity(data.get("psw") !== data.get("psw2") ? "Passwords should be equal" : "");
  });

  supabaseClient.auth.onAuthStateChange((event, session) => {
    if(!session && event !== 'PASSWORD_RECOVERY') open();
    onAuthStateChange({event, session})
  
    if (event === 'INITIAL_SESSION') {
  
    } else if (event === 'SIGNED_IN') {
      setTimeout(() => {
        updateUserLogin();
        if (this.openPopup) {
          this.openPopup.close();
          this.openPopup = void 0;
        }
      }, 0)
    } else if (event === 'SIGNED_OUT') {
  
    } else if (event === 'PASSWORD_RECOVERY') {
      showChangePasswordForm();
    } else if (event === 'TOKEN_REFRESHED') {
  
    } else if (event === 'USER_UPDATED') {
  
    }
  })

  placeHolder.select(".button-github-login").on("click", async () => {
      const { data, error } = await supabaseClient.auth.signInWithOAuth({
        provider: 'github',
        options: {
          redirectTo: location.origin + "/tools/auth/",
          skipBrowserRedirect: true
        }
      })
      console.log(error, data)
      
      this.openPopup = openPopup(data.url, "OAuth", screen.width * 0.3, screen.height * 0.6);

      switchUserLogin();
      updateUserLogin();
  });

  placeHolder.select(".button-google-login").on("click", async () => {
      const { data, error } = await supabaseClient.auth.signInWithOAuth({
      provider: 'google',
      options: {
        queryParams: {
          access_type: 'offline',
        },
        scopes: ["email", "profile"],
        redirectTo: location.origin + "/tools/auth/",
        skipBrowserRedirect: true
      }
    });
    console.log(error, data);    

    if (!error) {
      this.openPopup = openPopup(data.url, "OAuth", screen.width * 0.3, screen.height * 0.6);
    }

    switchUserLogin();
    updateUserLogin();

  })

  placeHolder.select(".user-change-email").on("click", async () => {
    const logged = await isLogged();
    if (!logged.isLogged) return alert("Not logged in");
    showChangeEmailForm(logged.session.user.email);
  });

  placeHolder.select(".user-change-password").on("click", async () => {
    const logged = await isLogged();
    if (!logged.isLogged) return alert("Not logged in");
    showChangePasswordForm();
  });

  placeHolder.select(".user-delete-account").on("click", async () => {
    const logged = await isLogged();
    if (!logged.isLogged) return alert("Not logged in");
    showDeleteAccountForm(logged.session.user.id, logged.session.user.email);
  });

  function open() {
    placeHolder.select(".user-login-form").classed("signup", false).classed("forgot", false);
    switchUserLogin();
  }

  function openPopup(src, title, width, height) {
    var left = (screen.width - width) / 2;
    var top = (screen.height - height) / 4;
    return window.open(src, title, 'popup, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
  }
  
  function switchUserLogin(force) {
    _this.isUserLoginOpen = force || force === false ? force : !_this.isUserLoginOpen;
    placeHolder.classed("open", _this.isUserLoginOpen);
  }

  function switchToForgotPanel(prefillEmail) {
    placeHolder.select(".user-login-form").classed("forgot", true).classed("signup", false);
    const emailInput = placeHolder.select(".forgot-panel input[name='email']").node();
    if (emailInput && prefillEmail) emailInput.value = prefillEmail;
    placeHolder.select(".forgot-panel .error-msg").text("");
  }

  function showChangePasswordForm() {
    placeHolder.select('.change-action-wrapper').remove();

    const formHtml = `
        <div class="change-action-card fancy-art-deco-card">
          <span class="change-action-close button-close">×</span>
          <form class="change-action-form panel">
            <span>Change password</span>
            <label><b>New password</b></label>
            <input name="newPass" type="password" minlength="6" required placeholder="Enter new password">
            <label><b>Confirm password</b></label>
            <input name="newPass2" type="password" minlength="6" required placeholder="Confirm new password">
            <div class="actions">
              <button type="submit" class="button">Change password</button>
              <button type="button" class="button button-cancel">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    `;

    const wrapper = placeHolder.append('div').attr('class', 'change-action-wrapper');
    wrapper.html(formHtml);

    const modal = wrapper.select('.change-action-card');

    function removeModal() {
      wrapper.remove();
    }

    modal.select('.change-action-close').on('click', removeModal);
    modal.select('.button-cancel').on('click', removeModal);

    modal.selectAll('input[name="newPass"], input[name="newPass2"]').on('input', function() {
      this.setCustomValidity('');
    });

    modal.select('.change-action-form').on('submit', async event => {
      event.preventDefault();
      const form = event.target;
      const newPassInput = form.querySelector('input[name="newPass"]');
      const newPass2Input = form.querySelector('input[name="newPass2"]');
      newPassInput.setCustomValidity('');
      newPass2Input.setCustomValidity('');

      const data = new FormData(form);
      const newPass = data.get('newPass');
      const newPass2 = data.get('newPass2');

      if (!newPass || newPass.length < 6) {
        newPassInput.setCustomValidity('Password must be at least 6 characters');
        newPassInput.reportValidity();
        return;
      }
      if (newPass !== newPass2) {
        newPass2Input.setCustomValidity('Passwords do not match');
        newPass2Input.reportValidity();
        return;
      }

      const { error } = await changePassword(newPass);
      if (error) {
        const msg = (error && (error.message || error.error_description || error.error)) || String(error);
        newPassInput.setCustomValidity('Failed to change password: ' + msg);
        newPassInput.reportValidity();
        return;
      }

      good('Password updated successfully.', 5000);
      setTimeout(() => {
        removeModal();
      }, 1000);
    });
  }

  function showChangeEmailForm(prefillEmail) {
    placeHolder.select('.change-action-wrapper').remove();

    const formHtml = `
        <div class="change-action-card fancy-art-deco-card">
          <span class="change-action-close button-close">×</span>
          <form class="change-action-form panel change-email-form">
            <span>Change email</span>
            <label><b>New e-mail</b></label>
            <input name="newEmail" type="email" required placeholder="Enter new email">
            <div class="actions">
              <button type="submit" class="button">Change e-mail</button>
              <button type="button" class="button button-cancel">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    `;

    const wrapper = placeHolder.append('div').attr('class', 'change-action-wrapper');
    wrapper.html(formHtml);

    const modal = wrapper.select('.change-action-card');

    function removeModal() {
      wrapper.remove();
    }

    modal.select('.change-action-close').on('click', removeModal);
    modal.select('.button-cancel').on('click', removeModal);

    const form = modal.select('.change-email-form').node();
    const emailInput = form.querySelector('input[name="newEmail"]');
    if (prefillEmail) emailInput.value = prefillEmail;

    modal.select('input[name="newEmail"]').on('input', function() { this.setCustomValidity(''); });

    modal.select('.change-email-form').on('submit', async event => {
      event.preventDefault();
      const formEl = event.target;
      const newEmailInput = formEl.querySelector('input[name="newEmail"]');
      newEmailInput.setCustomValidity('');
      const data = new FormData(formEl);
      const newEmail = data.get('newEmail');
      if (!newEmail) {
        newEmailInput.setCustomValidity('Please enter a valid email');
        newEmailInput.reportValidity();
        return;
      }
      const { error } = await changeEmail(newEmail);
      if (error) {
        const msg = (error && (error.message || error.error_description || error.error)) || String(error);
        newEmailInput.setCustomValidity('Failed to change email: ' + msg);
        newEmailInput.reportValidity();
        return;
      }

      good('Email change requested. Check your inbox.', 5000);
      setTimeout(() => {
        removeModal();
        updateUserLogin();
      }, 1000);
    });
  }

  function showDeleteAccountForm(userId, userEmail) {
    // remove any existing form
    placeHolder.select('.change-action-wrapper').remove();

    const formHtml = `
        <div class="change-action-card fancy-art-deco-card">
          <span class="change-action-close button-close">×</span>
          <form class="change-action-form panel delete-account-form">
            <span>Delete account</span>
            <p style="margin:0.25em 0 0.5em 0; font-size:0.9em; color:rgba(255,255,255,0.8)">Type your e-mail to confirm permanent deletion.</p>
            <label><b>Your e-mail</b></label>
            <input name="confirmEmail" type="email" required placeholder="Enter your email to confirm">
            <div class="actions">
              <button type="submit" class="button danger">Delete account</button>
              <button type="button" class="button button-cancel">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    `;

    const wrapper = placeHolder.append('div').attr('class', 'change-action-wrapper');
    wrapper.html(formHtml);

    const modal = wrapper.select('.change-action-card');

    function removeModal() { wrapper.remove(); }

    modal.select('.change-action-close').on('click', removeModal);
    modal.select('.button-cancel').on('click', removeModal);

    const formSel = modal.select('.delete-account-form');
    const inputSel = formSel.select('input[name="confirmEmail"]');
    const inputNode = inputSel.node();
    inputSel.on('input', function() { this.setCustomValidity(''); });

    if (userEmail) inputNode.placeholder = userEmail;

    formSel.on('submit', async event => {
      event.preventDefault();
      inputNode.setCustomValidity('');
      const data = new FormData(event.target);
      const confirmEmail = data.get('confirmEmail');
      if (!confirmEmail) {
        inputNode.setCustomValidity('Please enter your email to confirm');
        inputNode.reportValidity();
        return;
      }
      if (confirmEmail.trim().toLowerCase() !== (userEmail || '').trim().toLowerCase()) {
        inputNode.setCustomValidity('Email does not match your account');
        inputNode.reportValidity();
        return;
      }

      const res = await deleteAccount();
      if (res.error) {
        const msg = (res.error && (res.error.message || res.error.error || res.error_description)) || String(res.error);
        inputNode.setCustomValidity('Failed to delete account: ' + msg);
        inputNode.reportValidity();
        return;
      }

      good('Account deleted. Signing out...', 5000);
      setTimeout(async () => {
        removeModal();
        await userLogout();
        updateUserLogin();
      }, 1000);
    });
  }

  async function updateUserLogin() {
    const logged = await isLogged();
    if (logged.isLogged) {
      placeHolder.select(".user-logged-name").text(logged.session.user.email);
      placeHolder.select(".user-logged-title").text(logged.session.user.email.split("@")[0]);
    }
    placeHolder.classed("logged", logged.isLogged);
  }

  async function userSignup(email, password) {
    const { data, error } = await supabaseClient.auth.signUp({ email, password });
    console.log(error, data);
    return { data, error };
  }

  async function userLogin(email, password) {
    const { data, error } = await supabaseClient.auth.signInWithPassword({ email, password });
    console.log(error, data);
    return { success: !error, error };
  }

  async function userLogout() {
    const { error } = await supabaseClient.auth.signOut({ scope: 'local' });
    return error ? false : true;
  }

  this.isLogged = false;

  async function isLogged() {
    const { data, error } = await supabaseClient.auth.getSession();
    return { 
      isLogged: data.session && true,
      session: data.session
    };
  }
  
  async function hashSHA2(string) {
    const utf8 = new TextEncoder().encode(string);
    const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((bytes) => bytes.toString(16).padStart(2, '0'))
      .join('');
    return hashHex;
  }

  // account management helpers
  async function changeEmail(newEmail) {
    try {
      // supabase JS v2: updateUser accepts { email }
      const { data, error } = await supabaseClient.auth.updateUser({ email: newEmail });
      console.log("changeEmail", error, data);
      return { data, error };
    } catch (e) {
      return { error: e };
    }
  }

  async function changePassword(newPassword) {
    try {
      const { data, error } = await supabaseClient.auth.updateUser({ password: newPassword });
      console.log("changePassword", error, data);
      return { data, error };
    } catch (e) {
      return { error: e };
    }
  }

  async function deleteAccount() {
    try {
        const { data, error } = await supabaseClient.functions.invoke('soft-delete-user') ;
        console.log("deleteAccount", error, data);
        return { data, error };
    } catch (e) {
      return { error: e };
    }
  }

  updateUserLogin();

}

export default UserLogin;